import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBriefcase, faUsers, faHardHat, faIdCard, faClock, faBook, 
  faClipboardList, faMoneyCheckAlt, faMoneyBillWave, faHandsHelping, 
  faImage, faEye, faStar, faQrcode, faUser, faLockOpen,
  faSadCry,
  faWallet,
  faSearch, faClipboardQuestion, faClockRotateLeft
} from '@fortawesome/free-solid-svg-icons';
import './JobsWorks.css';
// import bluehandsimage from '../../assets/gdashboard/BlueHands.webp';

function BPMJobsHome() {
  const authState = useSelector(state => state.authReducer);
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [searchQuery, setSearchQuery] = useState("");
  const [category, setCategory] = useState("Labour");
  const [searchCity, setSearchCity] = useState("Mumbai");

  const handleSearch = () => {
    // console.log("Search Query:", searchQuery);
    // console.log("Category:", category);
    // console.log("City:", city);
    // API Call for database fetching logic here
  };


  return (
    <MainLayout>
      <div className="min-h-full py-8 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 mt-12">
        <h2 className='text-3xl font-bold text-white text-center mb-6'>BPM Jobs</h2>
        <div className="min-h-[100vh] px-4">
          <div className="flex flex-col items-center mb-8 mt-16 border-2 border-yellow-200 rounded-md p-6">
            <div className="flex flex-row justify-center md:flex-row md:space-x-4 space-y-4 md:space-y-0 w-full">
              <label>
                <FontAwesomeIcon icon={faSearch} className='text-yellow-200 text-lg ml-4'/>
              </label>
              <input
                type="text"
                placeholder="Enter search keywords eg Analyst, Manager etc"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}
              >
                <option value="Process Analysts">Process Analysts</option>
                <option value="Process Managers">Process Managers</option>
                <option value="Process Executives">Process Executives</option>
                <option value="Process Consultant">Process Consultant</option>
                <option value="Process Interns">Process Interns</option>
                <option value="Process Supervisors">Process Supervisor</option>
              </select>
              <select
                value={searchCity}
                onChange={(e) => setSearchCity(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-3 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}
                >
                <option value="Any Location">Any Location</option>
                <option value="Mumbai">Mumbai</option>
                <option value="Delhi">Delhi</option>
                <option value="Bangalore">Bangalore</option>
                <option value="Ahmedabad">Ahmedabad</option>
                <option value="Hyderabad">Hyderabad</option>
                <option value="Chennai">Chennai</option>
                <option value="Pune">Pune</option>
              </select>
            </div>
            <div>
              <button
                onClick={handleSearch}
                className="bg-blue-800 text-white px-6 py-2 w-40 hover:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-800"
              >
                Search
              </button>
              <button
                onClick={handleSearch}
                className="bg-blue-800 text-white px-6 py-2 w-40 hover:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-800"
              >
                Instant
              </button>
            </div>
          </div>


          <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mb-250">
            <CardLink to="/sportsjob-iamavailable" icon={faHandsHelping} text="I am Available" />
            <CardLink to="/myprofile-sportsjobprofile" icon={faUser} text="My BPM Profile" />
            <CardLink to="/contact-genious-myqr" icon={faQrcode} text="My QR Code" />
            <CardLink to="/contact-genious/sports" icon={faIdCard} text="My Secure Digital Card" />
            <CardLink to={`/pub/sports/${userCode}`} icon={faLockOpen} text="My Public Digital Card" />
            <CardLink to="/chronocheck-home" icon={faClock} text="My Attendance" />
            <CardNoLink to="" icon={faBook} text="My Work Diary" />
            <CardNoLink to="" icon={faUser} text="Write My Bio-Data" />
            <CardNoLink to="" icon={faMoneyBillWave} text="Payments" />
            {/* <CardLink to="/contact-genious-change-profile-image" icon={faImage} text="Profile Image" /> */}

            <CardNoLink to="" icon={faClipboardQuestion} text="My Shortlisted Jobs" />
            <CardNoLink to="" icon={faClockRotateLeft} text="Jobs I Applied" />
            <CardNoLink to="" icon={faSadCry} text="Today I Was Jobless" />
            <CardNoLink to="" icon={faQrcode} text="My Search Log" />
            <CardNoLink to="" icon={faEye} text="Who Searched Me" />
            <CardNoLink to="" icon={faWallet} text="Price List" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-white p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-300 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default BPMJobsHome;


